var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.id)?_c('router-link',{attrs:{"to":{ name: 'userId', params: { id: _vm.id } }},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v(_vm._s(_vm.login || _vm.$tf('unknown')))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }